import script from "./CompRange.vue?vue&type=script&setup=true&lang=js"
export * from "./CompRange.vue?vue&type=script&setup=true&lang=js"

import "./CompRange.vue?vue&type=style&index=0&id=f9408f22&lang=css"

const __exports__ = script;

export default __exports__